import CustomSelectOption from "@components/CustomSelectOption";
import Pagination from "@components/Pagination";
import FloatScrollButton from "@components/ui/FloatScrollButton";
import NewCourses from "@components/ui/landing/NewCourses";
import Download from "assets/svg/download.svg";
import Surprise from "assets/svg/surprise.svg";
import { Button, SEOHEAD, Spinner } from "components";
import gate from "gate";
import React, { FC, useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { convertMiladiToJalali } from "src/utils";
import { Swiper, SwiperSlide } from "swiper/react";

let _timer: any | null = null;
const Index: FC = () => {
  const isFirstMounted = useRef(true);
  const [recommendedList, setRecommendedList] = useState<null | []>(null);
  const [totalCount, setTotalCount] = useState(null);
  const [searchData, setSearchData] = useState({
    search: "",
    pageSize: 15,
    pageNumber: 1,
    fieldSearchs: [
      {
        fieldName: "",
        text: "",
      },
    ],
  });
  const [variable, setVariable] = useState<number[]>([]);
  const { data } = useQuery("inputs", () => gate.mainInput(), {
    select: (data: any) => data?.data?.output,
  });

  const { mutate, data: rules, isLoading }: any = useMutation(gate.mainRules);

  // useEffect(() => {
  //   mutate({ ids: variable, searchDto: searchData });
  // }, [variable]);

  const handleInputs = (id: number) => {
    if (variable.includes(id)) {
      const newArray = variable.filter((item: any) => item !== id);
      setVariable(newArray);
    } else {
      setVariable((prev: number[]) => [...new Set([...prev, id])]);
    }
  };
  useEffect(() => {
    if (searchData) {
      mutate(
        { ids: variable, searchDto: searchData },
        {
          onSuccess: (data: any) => {
            if (!isFirstMounted.current) {
              const getOffsetTop =
                document.getElementById("postsWrapper")?.offsetTop;
              window.scrollTo({
                top:
                  getOffsetTop && getOffsetTop > 0
                    ? getOffsetTop - 30
                    : getOffsetTop,
                behavior: "smooth",
              });
            }
            setRecommendedList(data?.data?.output?.recommended);
            setTotalCount(data?.pagination.totalCount);
            if (isFirstMounted.current) {
              isFirstMounted.current = false;
            }
          },
        }
      );
    }
  }, [searchData, variable]);

  const onShowChange = (data: { key: string; value: string }) => {
    setSearchData({
      ...searchData,
      pageSize: +data.key,
      pageNumber: 1,
    });
  };

  const pageNumbersHandler = (pageNumber: number, pageSize: number) => {
    if (totalCount) {
      const totalPages =
        totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
      // last page
      if (pageNumber === totalPages) {
        return (
          <>
            {pageNumber * pageSize - pageSize + 1} - {totalCount}
          </>
        );
        // first page
      } else if (pageNumber === 1) {
        return (
          <>
            {pageNumber} - {pageSize}
          </>
        );
        // middle pages
      } else {
        return (
          <>
            {pageNumber * pageSize - pageSize + 1} - {pageNumber * pageSize}
          </>
        );
      }
    }
    return null;
  };
  const scrollToPostsWrapper = () => {
    if (_timer) {
      clearTimeout(_timer);
    }
    _timer = setTimeout(() => {
      const getOffsetTop = document.getElementById("postsWrapper")?.offsetTop;
      window.scrollTo({
        top:
          getOffsetTop && getOffsetTop > 0 ? getOffsetTop - 30 : getOffsetTop,
        behavior: "smooth",
      });
    }, 0);
  };
  const onPageChange = (page: number) => {
    scrollToPostsWrapper();
    setSearchData({
      ...searchData,
      pageNumber: page,
    });
  };
  const getType = (item: any, type: string) => {
    const found = item.items.filter((values: any) => values.fieldName === type);
    if (found && found.length) {
      if (type === "Image") {
        return found[0].value ?? "images/nc-img.png";
      }
      return found[0].value;
    }
    return undefined;
  };
  return (
    <>
      <SEOHEAD
        {...{
          canonical: "https://dadbanan.com/rules/قوانین-و-مقررات",
          title: "مجموعه قوانین و مقررات کاربردی | مؤسسه دادبانان",
          keyword: ["قوانین و مقررات"],
          seoDescription:
            "این قسمت جهت دسترسی بهتر به قوانین و مقررات همچنین مصوبات و آیین نامه های مربوط با حقوق کسب و کار پیش بینی شده است",
        }}
      />
      <div>
        <div
          className="img-header flex flex-col justify-center"
          style={{
            backgroundImage: `url("/images/cover.jpg")`,
          }}
        >
          <div className="px-[10%] lg:px-[13%]">
            <div className="py-6 2xl:py-32">
              <h1 className="mb-[30px] text-xl text-white 2xl:text-[40px]">
                مجموعه قوانین و مقررات
              </h1>
              <p className="text-xs text-white 2xl:text-xl">
                {/* لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                                استفاده از طراحان گرافیک است. ایپسوم متن ساختگی با تولید سادگی
                                نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.متن ساختگی با
                                تولید سادگی متن ساختگی با تولید سادگی */}
              </p>
            </div>
          </div>
        </div>
        <div className="px-[10%] lg:px-[13%]">
          <div className="scrollbar-none mt-16 mb-14 flex w-full items-center overflow-x-auto">
            <span className="ml-5 whitespace-nowrap text-sm 2xl:text-base">
              دسته بندی:
            </span>
            <Swiper
              slidesPerView="auto"
              pagination={false}
              className="mySwiper"
            >
              {data?.map(({ name, id }: any) => (
                <SwiperSlide className="!ml-2 !w-min" key={id}>
                  <Button
                    onClick={() => handleInputs(id)}
                    CClassName={`text-[#2445AB] whitespace-nowrap rounded-full text-xs 2xl:text-base border px-2 py-1 border-[#2445AB] ${
                      variable?.includes(id) && "bg-blue/20"
                    }`}
                    key={JSON.stringify(id)}
                  >
                    {name}
                  </Button>
                </SwiperSlide>
              ))}
            </Swiper>
            {/* {data?.map(({ name, id }: any) => (
                            <Button
                                onClick={() => handleInputs(id)}
                                CClassName={`text-[#2445AB] whitespace-nowrap rounded-full text-xs 2xl:text-base border px-2 2xl:ml-5 ml-2 py-1 border-[#2445AB] ${
                                    variable?.includes(id) && 'bg-blue/20'
                                }`}
                                key={JSON.stringify(id)}
                            >
                                {name}
                            </Button>
                        ))} */}
          </div>
          <div className="grid grid-cols-1">
            {rules?.pagination?.totalCount ? (
              <>
                {rules?.data?.output?.table?.rows.map((item: any) => (
                  <div
                    key={item?.id}
                    className="mb-2 grid h-auto w-full grid-cols-[_101px,_1fr] rounded bg-white shadow md:mb-10 2xl:h-[246px] 2xl:grid-cols-[_auto,_1fr]"
                  >
                    <div
                      className="ml-2 h-full p-2 2xl:ml-[30px] 2xl:h-[246px]"
                      style={{
                        background:
                          "linear-gradient(270.77deg, rgba(54, 100, 147, 0.88) 0.69%, rgba(4, 128, 212, 0.64) 17.65%, rgba(39, 177, 187, 0.51) 46.42%, rgba(255, 255, 255, 0.1) 74.78%, #FFFFFF 99.26%)",
                      }}
                    >
                      <div className="flex h-full items-center justify-center bg-white">
                        <img
                          loading="lazy"
                          src={getType(item, "Image")}
                          alt={getType(item, "Title")}
                          className="mr-2 h-auto w-[85px] 2xl:w-[200px]"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col justify-between py-2 pl-5 text-[#4E4E56] 2xl:py-9">
                      <div>
                        <div className="mb-2 flex w-full justify-between">
                          <div>
                            <h2 className="text-sm md:text-base 2xl:text-xl">
                              {getType(item, "Title")}
                            </h2>
                          </div>
                          {getType(item, "StrSubjects") &&
                            getType(item, "StrSubjects").length !== 0 && (
                              <div className="hidden h-min whitespace-nowrap rounded-full bg-[#2445AB]/20 px-1 text-[#2445AB] 2xl:flex">
                                {getType(item, "StrSubjects")}
                              </div>
                            )}{" "}
                        </div>
                        <p
                          className="hidden text-[10px] text-[#7D7D7D] 2xl:block 2xl:text-sm"
                          dangerouslySetInnerHTML={{
                            __html: getType(item, "Description"),
                          }}
                        />
                      </div>
                      <div className="mt-2 flex w-full flex-col justify-between 2xl:flex-row">
                        <div className="flex">
                          {getType(item, "ApprovalReference") && (
                            <div className="ml-2 flex items-center text-[10px] text-[#7D7D7D] md:text-sm 2xl:text-base">
                              مرجع تصویب: {getType(item, "ApprovalReference")}{" "}
                            </div>
                          )}{" "}
                          {getType(item, "ApprovalDate") && (
                            <div className="hidden items-center text-[10px] text-[#7D7D7D] md:flex md:text-sm 2xl:text-base">
                              تاریخ تصویب :
                              <span className="mr-1">
                                {convertMiladiToJalali(
                                  getType(item, "ApprovalDate")
                                )}{" "}
                              </span>
                            </div>
                          )}{" "}
                        </div>
                        <a
                          download
                          href={getType(item, "Url")}
                          title={getType(item, "UrlName")}
                          className="mt-1 flex w-min items-center 2xl:rounded 2xl:border 2xl:border-blue 2xl:py-1 2xl:px-3"
                        >
                          <Download className="ml-[10px] scale-90 2xl:scale-100" />
                          <span className="text-[10px] text-blue md:text-sm 2xl:text-base">
                            دانلود
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : isLoading ? (
              <Spinner className="mx-auto my-10 h-10 w-10" />
            ) : (
              <div className="flex h-[60vh] items-start gap-x-5 text-xs md:text-base">
                <Surprise />
                <p>
                  لطفا یکی از گزینه های فیلتر را انتخاب کنید آیتمی یافت نشد.
                </p>
              </div>
            )}

            <div className="mb-16 grid grid-cols-1 md:grid-cols-2">
              <div>
                {totalCount && totalCount > searchData.pageSize ? (
                  <Pagination
                    totalCount={totalCount}
                    pageSize={searchData.pageSize}
                    onPageChange={onPageChange}
                  />
                ) : undefined}
              </div>
              <div>
                {(totalCount && totalCount > searchData.pageSize) ||
                searchData.pageSize !== 15 ? (
                  <div className="mt-4 flex items-center justify-center md:mt-0 md:justify-end">
                    <span className="ml-5">
                      نمایش{" "}
                      {pageNumbersHandler(
                        searchData.pageNumber,
                        searchData.pageSize
                      )}{" "}
                      از {totalCount}
                    </span>
                    <CustomSelectOption
                      list={[
                        { key: "15", value: "نمایش 15" },
                        { key: "20", value: "نمایش 20" },
                        { key: "30", value: "نمایش 30" },
                        { key: "50", value: "نمایش 50" },
                      ]}
                      isRtl={false}
                      onChange={onShowChange}
                    />
                  </div>
                ) : undefined}
              </div>
            </div>
            {recommendedList ? (
              <div className="mb-20">
                {recommendedList.length == 0 ? (
                  <div className="flex h-[60vh] items-start gap-x-5 text-xs md:text-base">
                    <Surprise />
                    <p>موردی یافت نشد.</p>
                  </div>
                ) : (
                  <NewCourses
                    title="دوره ها و بسته های پیشنهادی"
                    data={recommendedList}
                    breakpoints={{
                      300: {
                        slidesPerView: 1,
                        spaceBetween: 5,
                      },
                      375: {
                        slidesPerView: 1.1,
                        spaceBetween: 5,
                      },
                      767: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                      },
                      1024: {
                        slidesPerView: 4,
                        spaceBetween: 24,
                      },
                    }}
                  />
                )}
              </div>
            ) : undefined}
          </div>
        </div>
      </div>
      <FloatScrollButton />
    </>
  );
};

export default Index;
